module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrow-up-263af9bdfb4c0413f6ef40f31a130112.svg";